import { colors } from './colors';
import { colorsLight } from './colorsLight';

/**
 * Return the appropriate color palette for the given MUI palette mode.
 * Use inside `makeStyles` callbacks where `theme` is available:
 *
 * ```ts
 * const useStyles = makeStyles()((theme) => {
 *   const c = getColors(theme.palette.mode);
 *   return { ... };
 * });
 * ```
 */
export const getColors = (mode: 'light' | 'dark') =>
  mode === 'light' ? colorsLight : colors;
